import React, { Component } from 'react';

import Page from '../page';
import Privacy from '../privacy';

export default class extends Component {

    render() {

        return (
            <Page {...this.props}>
                <Privacy />
            </Page>
        );
    }
};
